<template>
  <div>
    <div v-for="(insurance, insuranceNo) in insurances" :key="insuranceNo">
      <hr />
      <UsWorkerClassificationInsuranceProofFormSection
        :insurance="insurance"
        :form-data="form[insurance.key]"
      />
    </div>
    <div class="form-group">
      <div class="col-md-6 col-md-offset-3 text-center" data-vue-app>
        <SubmitButton :text="$t('Save')" auto-submit />
      </div>
    </div>
  </div>
</template>

<script>
import SubmitButton from '@/components/SubmitButton.vue'
import UsWorkerClassificationInsuranceProofFormSection from './UsWorkerClassificationInsuranceProofFormSection.vue'

export default {
  name: 'UsWorkerClassificationInsuranceProofForm',
  components: {
    UsWorkerClassificationInsuranceProofFormSection,
    SubmitButton,
  },
  props: {
    insurances: {
      type: Object,
      default: () => {},
    },
    complianceInsurances: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    const form = {}
    this.insurances.forEach((insurance) => {
      form[insurance.key] = this.complianceInsurances[insurance.key] || {
        has_insurance: false,
        insurance_policy_limit: null,
        proof_of_insurance_file_ids: null,
        insurance_account_no: null,
      }
    })

    return {
      form,
    }
  },
}
</script>

<style scoped></style>
